import config from '@/config'
import Listings from '@/models/Listings'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.GOKOLLAB_SERVER_URL)

export default class ListingsService extends BaseService<Listings> {
  protected basePath = ''

  model() {
    return Listings
  }

  constructor() {
    super(config?.GOKOLLAB_LOCATION_ID)
    this.basePath = `/${config?.GOKOLLAB_LOCATION_ID}/listings`
  }

  async getListingsByExternalId(externalId: string) {
    const response = await http.get(`${this.endpoint}/${externalId}`)
    return response.data
  }

  async getListingCategoryByExternalId(externalId: string) {
    const response = await http.get(
      `${this.endpoint}/external-id/${externalId}/category`
    )
    return response.data
  }

  async refreshCategoryByExternalId(externalId: string) {
    const response = await http.post(
      `${this.endpoint}/external-id/${externalId}/refresh-category`
    )
    return response.data
  }

  async activateListingByExternalId(externalId: string, locationId: string) {
    const response = await http.post(`${this.endpoint}/activate`, {
      listings: [
        {
          type: 'Community',
          externalId,
          locationId,
        },
      ],
    })
    return response.data
  }

  async deactivateListingByExternalId(externalId: string) {
    const response = await http.post(`${this.endpoint}/deactivate`, {
      externalIds: [externalId],
    })
    return response.data
  }

  async updateSlugByExternalId(externalId: string, slug: string) {
    const response = await http.patch(
      `${this.endpoint}/external-id/${externalId}`,
      {
        slug,
      }
    )
    return response.data
  }
}
